
import {locales} from '~/data/locales'

export default
	data: ->
		selectedLocale: @$i18n.localeProperties.code

	computed:
		locales: -> locales.filter((locale) => @availableSites?.includes(locale.siteHandle)).map( (locale) -> ({
			label: locale.label
			value: locale.locale
		}))

		availableSites: -> @$store.state.localization?.availableSites

	watch: selectedLocale: (locale) -> @$router.push(@switchLocalePath(locale))

